import { LeagueLimitsCategory } from '@/constants';
import { createSimpleDictionary } from '@/stores/utils/createSimpleDictionary';

export const leagueLimitsCategoryDictionary = createSimpleDictionary([
    { id: LeagueLimitsCategory.Pro, name: 'dictionaries.clLimits.pro' },
    { id: LeagueLimitsCategory.High, name: 'dictionaries.clLimits.high' },
    { id: LeagueLimitsCategory.Medium, name: 'dictionaries.clLimits.medium' },
    { id: LeagueLimitsCategory.Low, name: 'dictionaries.clLimits.low' },
    { id: LeagueLimitsCategory.Micro, name: 'dictionaries.clLimits.micro' },
]);
